module.exports = __webpack_public_path__ + "static/media/cetus.876c6d23.png";